<div class="dmv-pickup-method inner-home">
    <div class="container">
      <div class="row no-margin">
        <!--heading section starts here-->
        <div class="col-6 col-sm-2 mt-4 ">
          <a >
             <button class="btn btn-primary btn-back top-back-button"
              (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
          </a>  
        </div>
  
        <div class="col-12 col-sm-8 mt-4">
          <div id="searchResu">Choose Your Delivery Option</div>
          <!--p id="addthereco">There are two methods to obtain your new plate and registration. Please choose one below:</p-->
        </div>
  
  
         <div class="col-6 col-sm-2 icon-cart mt-4">
        <dmv-shoping-cart [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations"></dmv-shoping-cart>
        </div>
  
        <!--heading section ends here-->
  
         
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
         {{errorMessage}}
        </div>
   
      <div class="col-12 col-sm-6 mt-5 mb-4 pickupContainer">
                <div class="card card-pickup" (click)="pickup('mailing')">
                    <div class="card-body">
                       <div class="row card-pickup-main">
                            <div class="col-4 card-pickup-icon">
                                 <i class="icon-group-10"> <svg-image  [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig.primaryColor" name="by-mail" [width]="90" [height]="90"></svg-image>
                                       </i>
                              
                           </div>
                           <div class="col-8">
                                <h4 id="byMail">By Mail</h4>
                               <p id="orderingby">
                                Ordering by mail is easy and convenient. However there may be an additional charge for shipping.
                               </p>
                           </div>
                       </div>
                    </div>
                </div>
            </div>
           <div class="col-12 col-sm-6 mt-5 mb-4 pickupContainer" *ngIf="globalService.cartNature !== 'manual'" >
                <div class="card card-pickup" (click)="pickup('in-person')">
                    <div class="card-body">
                        <div class="row card-pickup-main">
                               <div class="col-4 card-pickup-icon">
                                   <i class="icon-group-10"> <svg-image  [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="in-person" [width]="90" [height]="90"></svg-image>
                                       </i>
                                 
                               </div>
                        
                               <div class="col-8">
                                    <h4 id="byMail">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.pickupBranding}}</h4>
                                   <p id="orderingby">
                                   {{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.pickupDescription}}
                                   </p>
                               </div>
                        </div>
                    </div>
                </div>
            </div>
  
      </div>
     </div>
  </div>

 